function debounce(func, delay) {
  let debounceTimer
  return function () {
    const context = this
    const args = arguments
    clearTimeout(debounceTimer)
    debounceTimer = setTimeout(() => func.apply(context, args), delay)
  }
}

function setCurrentDate() {
  const date = new Date()
  const currentDate = date.toLocaleDateString('en-CA', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  const dateEl = document.querySelector('.current_date')
  if (dateEl) {
    dateEl.innerHTML = currentDate
  }
}

function formatNumberWithThousandsSeparator(number, symbol) {
  symbol = symbol || '$'
  number = number.toString()
  return symbol + number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const calculateSavings = (config, type, rate, monthlyContribution, investmentLength) => {
  // Reset balance arrays
  config.currentSavings[type] = []

  const calculatedRate = calculateRate(rate)

  let calculatedTotal = config.currentValues.initial_investment
  config.currentSavings[type].push(calculatedTotal.toFixed(2))

  for (let i = 0; i < investmentLength; i++) {
    calculatedTotal = endingBalance(1, calculatedTotal, monthlyContribution, calculatedRate).balance

    config.currentSavings[type].push(calculatedTotal.toFixed(2))
  }
}

const futureValueAnnualTracking = (config, type, annualRate, totalMonths) => {
  const rate = annualRate / 100 // Convert percentage to decimal
  const years = Math.floor(totalMonths / 12) // Total years
  const extraMonths = totalMonths % 12 // Additional months

  let totalValue = config.currentValues.initial_investment // Start with initial investment
  // let totalInterest = 0 // Track interest earned over time
  // let contributions = config.currentValues.initial_investment // Track contributions made

  // let results = [] // Store yearly breakdown
  config.currentSavings[type] = [] // Store yearly breakdown
  config.currentSavings[type].push(totalValue.toFixed(2))

  // Loop through each full year
  for (let year = 1; year <= years; year++) {
    // Apply interest to total value
    totalValue *= 1 + rate

    // Add the annual contributions after interest is applied
    // totalValue += annualContribution
    // contributions += annualContribution

    // Calculate interest earned this year
    // let interestEarned = totalValue - contributions

    // Store results for this year
    config.currentSavings[type].push(totalValue.toFixed(2))
    // config.currentSavings[type].push({
    //   year,
    //   totalValue: totalValue.toFixed(2),
    //   totalInterest: interestEarned.toFixed(2),
    // })
  }

  // Handle extra months if any
  if (extraMonths > 0) {
    // Apply partial interest for extra months
    const partialGrowth = Math.pow(1 + rate, extraMonths / 12)
    totalValue *= partialGrowth

    // No new contributions in partial year
    // let interestEarned = totalValue - contributions

    config.currentSavings[type].push(totalValue.toFixed(2))
    // config.currentSavings[type].push({
    //   year: years + 1, // Represent the extra months as the final year
    //   totalValue: totalValue.toFixed(2),
    //   totalInterest: interestEarned.toFixed(2),
    // })
  }
}

function calculateRate(percentage) {
  return percentage / 100
}

function endingBalance(year, initialBalance, contributionAmount, rate) {
  // Recursive function to calculate balances
  if (year === 0) {
    return { balance: initialBalance, interestTotal: 0 }
  }

  const { balance: priorYearBalance, interestTotal: priorInterestTotal } = endingBalance(
    year - 1,
    initialBalance,
    contributionAmount,
    rate,
  )

  const priorYearInterest = priorYearBalance * rate
  const newContributionInterest = (13 / 2) * contributionAmount * rate

  const cumulativeBalance = priorYearBalance + 12 * contributionAmount + priorYearInterest + newContributionInterest
  const newInterestTotal = priorInterestTotal + priorYearInterest + newContributionInterest

  return { balance: cumulativeBalance, interestTotal: newInterestTotal }
}

export { futureValueAnnualTracking, calculateSavings, debounce, formatNumberWithThousandsSeparator, setCurrentDate }
